import { PastOnlineItemController } from "./past-item.controller";
import "./item-bids-dialog/item-bids-trigger.component";
import "./link-payment-states/link-payment-states.component";
import "./payment-actions/payment-actions.component";

angular
    .module("thor.online-containers.edit.past-item.component", [
        "thor.online-containers.edit.item-bids-trigger.component",
        "thor.online-containers.edit.link-payment-states.component",
        "thor.online-containers.edit.payment-actions.component"
    ])
    .component("pastOnlineItem", {
        bindings: {
            containerEndDate: "<",
            containerId: "<",
            contractId: "<",
            getItems: "&",
            item: "<",
            pastItemStatus: "<",
            saleCurrency: "<",
            saleDepositAmount: "<",
            salePaymentDeposit: "<",
            selectedLang: "<"
        },
        controller: PastOnlineItemController,
        template: require("./past-item.html")
    });
